// utils/setTitle.js

export function setTitle(appName) {
  if (!appName) return;

  document.title = appName;
}
